export default __webpack_public_path__ + "static/media/david6.970e1fe7.jpg";